module.exports = __webpack_public_path__ + "static/media/Dimitri-01.77233f95.svg";